import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import useUsuario from "../../hooks/useUsuario";
import { Button } from "primereact/button";
import { useLocation,useNavigate } from "react-router-dom";
import Slider from "../../components/slider/Slider";
import "../../components/Inicio/FormsEva.scss"
import "./Login.scss";
import Boton from "../../components/Boton/Boton";
import * as Iconsax from "iconsax-react";
import InputDefault from "../../components/InputDefault/InputDefault"
import InputIcon from "../../components/InputIcon/InputIcon"
import { Link } from 'react-router-dom';
import * as constantes from "../../constants/constantes";

const ENDPOINT = constantes.URLAPI;

export default function Login() {
    const [checked, setChecked] = useState(false);
    const setPassword = useState("");
    const setUserName = useState("");
    const [passwordType, setpasswordType] = useState("password");
    const [modalOpen, setModalOpen] = useState(false);  // Estado para abrir/cerrar el modal
    const [correo, setCorreo] = useState("");  // Estado para el correo en el modal
    const [mensajeError, setMensajeError] = useState("");  // Mensaje de error en el modal
    const [isResetSuccess, setIsResetSuccess] = useState(false); // Asegúrate de declararlo
    const { isloginLoading,hasLoginError,login, isLogged } = useUsuario();
    const [codigoColaborador, setCodigoColaborador] = useState("");
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {

        if (isLogged)
        {
            navigate("/Dashboard/Home");
        }
    }, [isLogged]);

    const handleSubmit = (e) =>{
        e.preventDefault()
        login()
    };
    const schema = Yup.object().shape({
        username: Yup.string().required("El código de colaborador es un campo obligatorio"),
        password: Yup.string().required("Contraseña es un campo obligatorio").min(5, "La contraseña debe tener al menos 5 caracteres"),
    });

    const togglePassword = () => {
        if (passwordType === "password") {
            setpasswordType("text");
            return;
        }
        setpasswordType("password");
    };

    const Logarse = async(userName,password,setSubmitting)=>{
        await login({ userName, password},()=>setSubmitting(false));
    }

    const openModal = () => {
        setCorreo('');
        setMensaje('');
        setError('');
        setModalOpen(true);
    };

    const closeModal = () => {
        setCorreo('');
        setMensaje('');
        setError('');
        setModalOpen(false);
        navigate("/Login");  // Redirige al login
    };

    const handleResetPasswordSubmit = async (e) => {
            e.preventDefault();
        const username = codigoColaborador;
        if (correo) {
            //setModalOpen(false);
            try{
                const response = await fetch(`${ENDPOINT}/Usuario/LoginEmail`,{
                //const response = await fetch('http://localhost:7152/api/LoginEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ correo })
              });

              const data = await response.json();
              console.log("response llegó", response);
              console.log("data llegó", data);

              if (response.ok ) {
                 if (data?.data?.statusCode === 200){
                    setMensaje('Se ha enviado un correo con el enlace para restablecer tu contraseña.');
                    setError('');

                     setTimeout(() => {
                        setModalOpen(false);
                    }, 5000);

                  } else{
                    setError(data?.data?.message || 'No se pudo enviar el correo.');
                    setMensaje('');

                    setTimeout(() => {
                        openModal();
                    }, 3000);
                  }
              } else {
                setError('Error en la respuesta del servidor.');
                setMensaje('');
              }
              //alert(`Enlace de restablecimiento enviado a ${correo} ${username}` );
            } catch (err) {
                setError('Ocurrió un error al enviar la solicitud.');
                setMensaje('');
            }
        } else {
            setMensaje("Por favor, ingrese un correo válido");
        }
    };

    return (
        <>
             {/* Formulario de login */}
            <Formik
                enableReinitialize
                validationSchema={schema}
                initialValues={{ username: "", password: "" }}
                onSubmit={(values,{ setSubmitting }) => {

                    // Alert the input values of the form that we filled
                    let userName = values.username;
                    let password = values.password;

                    Logarse(userName,password,setSubmitting)
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting,setSubmitting }) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <Slider/>
                                <div className="card contentLogin">
                                {/* <div className="surface-card p-4 shadow-2 border-round w-full lg:w-6"> */}
                                    <div className="text-center form-img">
                                        <img src="images/login/logo_INLEARNING.png" alt="hyper" width={365} />
                                    </div>

                                    <div className="form-login">
                                    {
                                        hasLoginError && <p className="error">Credenciales no validas</p>

                                    }
                                        <label htmlFor="CodigoColaborador" className="peva-label">
                                            Código Colaborador
                                        </label>
                                        <InputDefault
                                            id={"CodigoColaborador"}
                                            type="text"
                                            placeholder="Escribe aquí"
                                            name="username"
                                            onChange={(e) =>{
                                                handleChange(e);
                                                setCodigoColaborador(e.target.value);
                                            }}
                                            onBlur={handleBlur}
                                            className="grey"
                                            height={48}
                                            />
                                            <p className="error">{errors.username && touched.username && errors.username}</p>

                                        <label htmlFor="Password" className="peva-label">
                                            Contraseña
                                        </label>
                                        <div className="peva-input-icon">
                                            <InputIcon
                                                id="Password"
                                                type={passwordType}
                                                className = "grey"
                                                placeholder="Escribe aquí"
                                                name="password"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                icon={passwordType === "password"?<Iconsax.EyeSlash /> : <Iconsax.Eye />}
                                                onClickIcon={togglePassword}
                                                width="100%"
                                                height={48}
                                            />
                                            <p className="error">{errors.password && touched.password && errors.password}</p>
                                        </div>

                                        {/* <Button label="Ingresar"  className="peva-button-login" to="./Inicio" disabled={isloginLoading}/> */}
                                        <div className="form-footer">
                                            <Boton nombre={"Ingresar"} color="secondary" widths="100%" type="submit" loading={isSubmitting}></Boton>
                                        </div>
                                        <div className="text-center mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                style={{ color: 'rgb(244, 118, 41)' }}
                                                onClick={openModal}
                                            >
                                                ¿Has olvidado tu contraseña?
                                            </button>
                                        </div>

                                    </div>
                                </div>

                        </div>

                        {/* </div> */}
                    </form>
                )}
            </Formik>

            {/* Modal de restablecimiento de contraseña del usuario*/}
            {modalOpen && (
                <div className="modal-overlay" >
                    <div className="modal-content" >
                        <div  className="form-login">

                                <div style={{ height: '100px'}} >
                                    <br></br>
                                    <h4>Restablece tu contraseña</h4>
                                    <br></br>
                                    <p><strong>Ingresa tu dirección de correo corporativo y te enviaremos un enlace para restablecer tu contraseña.</strong></p>
                                </div>
                                <br></br>
                                <div >
                                    {isResetSuccess ? (
                                    <div className="mb-3">
                                        <p>Su contraseña fue restablecida, le enviamos un mensaje a su correo para restablecer.</p>
                                    </div>
                                    ) : (

                                    <form onSubmit={handleResetPasswordSubmit}>

                                        <div className="form-control   mb-3">
                                            {/* <label>Correo</label> */}
                                            <br></br>
                                            <input
                                                type="email"
                                                className="form-control-input"
                                                value={correo}
                                                onChange={(e) => setCorreo(e.target.value)}
                                                required
                                                placeholder="Ingresa tu correo corporativo"
                                            />
                                        </div>

                                        <div className="form-footer"  >
                                            <button
                                                className="btn btn-primary peva-button-login"
                                                type="submit"
                                            >
                                                Restablecer
                                            </button>
                                        </div>

                                        {/* <Link to="/Login" className="peva-request-pass">Volver al login</Link> */}
                                    </form>

                                )}
                                {/* El enlace para volver al login */}
                                <div className="text-center mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-link"
                                        onClick={closeModal}
                                    >
                                        <strong>Volver al Inicio</strong>
                                    </button>
                                </div>

                                {mensaje && <p style={{ color: 'green' }}>{mensaje}</p>}
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

//export default Login;
